// extracted by mini-css-extract-plugin
export default {"commentTitle":"workOrderDetail_commentTitle__VB73j","commentBox":"workOrderDetail_commentBox__ENqP7","commentItem":"workOrderDetail_commentItem__8GWw+"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"commentTitle\":\"workOrderDetail_commentTitle__VB73j\",\"commentBox\":\"workOrderDetail_commentBox__ENqP7\",\"commentItem\":\"workOrderDetail_commentItem__8GWw+\"}";
        // 1793760840515
        var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  